import React from 'react';

export default function Flex({
  children,
  direction = 'row',
  justifyContent = 'flex-start',
  alignItems = 'flex-start',
  flexWrap = 'nowrap',
  gap,
  margin,
  style = {},
  className = '',
  ...props
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: direction,
        alignItems,
        justifyContent,
        flexWrap,
        gap,
        margin,
        ...style,
      }}
      className={className}
      {...props}
    >
      {children}
    </div>
  );
}
